type TranslationFiles = {
    [key: string]: { [key: string]: any } | undefined
}

const translationFiles: TranslationFiles = {}

function loadTranslations(langCode: string): { [key: string]: any } {
    if (!translationFiles[langCode]) {
        try {
            const translations = require(`./../public/locales/${langCode}.json`)
            translationFiles[langCode] = translations.default || translations
        } catch (error) {
            console.error(`Error loading ${langCode} translations:`, error)
            translationFiles[langCode] = {}
        }
    }
    return translationFiles[langCode] || {}
}

function getNestedValue(obj: any, path: string): string | undefined {
    const value = path.split(".").reduce((current, key) => {
        return current && current[key] !== undefined ? current[key] : undefined
    }, obj)
    return typeof value === "string" ? value : undefined
}

export function t(
    langCode: string,
    key: string,
    params?: Record<string, string | number>
): string {
    // First try to get translation in requested language
    const translations = translationFiles[langCode] || loadTranslations(langCode)
    let translation: string | undefined = getNestedValue(translations, key)

    // If no translation found in requested language, try English (nested)
    if (translation === undefined && langCode !== "en") {
        const englishTranslations = translationFiles["en"] || loadTranslations("en")
        translation = getNestedValue(englishTranslations, key)
        // If still not found, try flat key in English
        if (translation === undefined) {
            const lowerCaseKey = key.toLowerCase()
            const englishKeys = Object.keys(englishTranslations).filter(
                k => k.toLowerCase() === lowerCaseKey
            )
            const fallbackTranslation =
                englishKeys.length > 0 ? englishTranslations[englishKeys[0]] : key
            translation =
                typeof fallbackTranslation === "string" ? fallbackTranslation : key
        }
    }

    // If still no translation found, try flat key in requested language
    if (translation === undefined) {
        const lowerCaseKey = key.toLowerCase()
        const keys = Object.keys(translations).filter(
            k => k.toLowerCase() === lowerCaseKey
        )
        const fallbackTranslation = keys.length > 0 ? translations[keys[0]] : key
        translation = typeof fallbackTranslation === "string" ? fallbackTranslation : key
    }

    // Replace dynamic placeholders with values from `params`
    if (params && translation) {
        Object.entries(params).forEach(([key, value]) => {
            translation = translation!.replace(new RegExp(`{${key}}`, "g"), String(value))
        })
    }

    return translation || key
}
